import { ApiGetAllPriceLaddersResponse200Type } from 'src/api_openapi/v2/trading/apiGetAllPriceLadders';
import { OpenapiProxyStaffUpdatePriceLaddersParamsType } from 'src/api_openapi/generated/openapi_proxy_staff_update_price_ladders';
import { TradingPatchPriceLadderViewType } from 'src/api_openapi/v2/trading/schemas';
import { ApiPatchPriceLadderByKeyResponse200Type } from 'src/api_openapi/v2/trading/apiPatchPriceLadderByKey';

export type PriceLaddersVieModel = Record<string, {
    prices: Array<{
        d: number;
        enabled: boolean;
        f: string;
    }>;
}>;

interface StepsModel {
    enabled: boolean;
    price: {
        decimal: number;
        fractional: string;
    }
}

interface PriceModel { 
    d: number;
    enabled: boolean;
    f: string;
}

export interface PricesViewModel {
    prices: Array<PriceModel>;
}

const convertPriceToOldModel = (steps: Array<StepsModel> | null | undefined): PricesViewModel => {
    if (steps === undefined || steps === null) {
        console.error('Steps in price ladder are undefined');
        return {
            prices: [],
        };
    }

    const outModel = [];

    for (const step of steps) {
        outModel.unshift({
            d: step.price.decimal,
            enabled: step.enabled,
            f: step.price.fractional
        });
    }

    return {
        prices: outModel,
    };
};

export const convertPriceLaddersToOldModel = (data: ApiGetAllPriceLaddersResponse200Type): PriceLaddersVieModel => {
    const outModel: Record<string, PricesViewModel> = {};

    for (const priceLadder of Object.values(data)) {
        outModel[priceLadder.key] = convertPriceToOldModel(priceLadder.steps);
    }

    return outModel;
};

export const convertPriceLadderByKeyToOldModel = (data: ApiPatchPriceLadderByKeyResponse200Type): PricesViewModel => {
    return convertPriceToOldModel(data.steps);
};


export const convertOldMasterPriceLadderToNewModel = (data: OpenapiProxyStaffUpdatePriceLaddersParamsType): TradingPatchPriceLadderViewType => {
    const outModel: TradingPatchPriceLadderViewType = {
        steps: []
    };

    for (const priceLadder of data.requestBody.prices) {
        if (outModel.steps === undefined || outModel.steps === null) {
            console.error('Steps are undefined');
            return {
                steps: undefined
            };
        }

        outModel.steps.push({
            enabled: priceLadder.enabled,
            price: {
                decimal: priceLadder.d,
                fractional: priceLadder.f,
            }
        });
    }

    return outModel;
};
